// Product Own Cane JavaScript - Multi-Product Variant Version
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Product Gallery with Flickity
  const productSlideshow = document.querySelector('.Product__Slideshow');
  if (productSlideshow && typeof Flickity !== 'undefined') {
    // Get the flickity config from the data attribute
    const flickityConfig = productSlideshow.getAttribute('data-flickity-config');
    let options = {
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: true,
      watchCSS: true,
      dragThreshold: 8,
      initialIndex: 0,
      arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
    };
    
    if (flickityConfig) {
      try {
        const configFromData = JSON.parse(flickityConfig);
        options = { ...options, ...configFromData };
      } catch (e) {
        console.log('Could not parse flickity config');
      }
    }
    
    const flickity = new Flickity(productSlideshow, options);
    
    // Handle thumbnail navigation
    const thumbnailImages = document.querySelectorAll('.Product__SlideshowNavImage');
    thumbnailImages.forEach((thumb, index) => {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        flickity.select(index);
        
        // Update selected state
        thumbnailImages.forEach(t => t.classList.remove('is-selected'));
        this.classList.add('is-selected');
      });
    });
    
    // Update thumbnail selection when slide changes
    flickity.on('select', function() {
      thumbnailImages.forEach((thumb, index) => {
        thumb.classList.toggle('is-selected', index === flickity.selectedIndex);
      });
    });
    
    // Handle thumbnail scroll arrows
    const thumbnailScroller = document.querySelector('.Product__SlideshowNavScroller');
    const prevArrow = document.querySelector('.Product__SlideshowNavArrow--prev');
    const nextArrow = document.querySelector('.Product__SlideshowNavArrow--next');
    
    if (thumbnailScroller && prevArrow && nextArrow) {
      // Function to check scroll position and update arrow visibility
      function updateArrowVisibility() {
        const scrollLeft = thumbnailScroller.scrollLeft;
        const scrollWidth = thumbnailScroller.scrollWidth;
        const clientWidth = thumbnailScroller.clientWidth;
        const maxScroll = scrollWidth - clientWidth;
        
        // Only show arrows if content is scrollable
        if (scrollWidth > clientWidth) {
          // Show/hide prev arrow
          prevArrow.classList.toggle('is-visible', scrollLeft > 5);
          
          // Show/hide next arrow
          nextArrow.classList.toggle('is-visible', scrollLeft < maxScroll - 5);
        } else {
          // Hide both arrows if content doesn't overflow
          prevArrow.classList.remove('is-visible');
          nextArrow.classList.remove('is-visible');
        }
      }
      
      // Initial check
      updateArrowVisibility();
      
      // Update on scroll
      thumbnailScroller.addEventListener('scroll', updateArrowVisibility);
      
      // Update on window resize
      window.addEventListener('resize', updateArrowVisibility);
      
      // Handle arrow clicks
      prevArrow.addEventListener('click', function() {
        const scrollAmount = thumbnailScroller.clientWidth * 0.8;
        thumbnailScroller.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      });
      
      nextArrow.addEventListener('click', function() {
        const scrollAmount = thumbnailScroller.clientWidth * 0.8;
        thumbnailScroller.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      });
    }
    
    // Handle mobile navigation arrows
    const prevBtn = document.querySelector('.Product__SlideshowNavArrow--previous');
    const nextBtn = document.querySelector('.Product__SlideshowNavArrow--next');
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => flickity.previous());
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => flickity.next());
    }
    
    // Handle mobile dots
    const dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        flickity.select(index);
        dots.forEach(d => d.classList.remove('is-selected'));
        this.classList.add('is-selected');
      });
    });
    
    // Update mobile dots on slide change
    flickity.on('select', function() {
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-selected', index === flickity.selectedIndex);
      });
    });
  }
  
  // Cane Customizer Functionality with Multi-Product Support
  class CaneCustomizer {
    constructor() {
      // Initialize dynamic product loader if available
      this.productLoader = window.DYOCProductLoader || null;
      // Product IDs - These need to be set to your actual Shopify product IDs
      this.products = {
        product1: {
          id: null, // Will be set from data attribute
          minPrice: 130, // To be filled in later
          maxPrice: 269, // To be filled in later
          variants: {} // Will be populated from data
        },
        product2: {
          id: null, // Will be set from data attribute
          minPrice: 270, // To be filled in later
          maxPrice: 369, // To be filled in later
          variants: {} // Will be populated from data
        },
        product3: {
          id: null, // Will be set from data attribute
          minPrice: 370, // To be filled in later
          maxPrice: 469, // To be filled in later
          variants: {} // Will be populated from data
        },
        product4: {
          id: null, // Will be set from data attribute
          minPrice: 470, // To be filled in later
          maxPrice: 569, // To be filled in later
          variants: {} // Will be populated from data
        },
        product5: {
          id: null, // Will be set from data attribute
          minPrice: 570, // To be filled in later
          maxPrice: 669, // To be filled in later
          variants: {} // Will be populated from data
        },
        product6: {
          id: null, // Will be set from data attribute
          minPrice: 670, // To be filled in later
          maxPrice: 768, // To be filled in later
          variants: {} // Will be populated from data
        },
        product7: {
          id: null, // Will be set from data attribute
          minPrice: 769, // To be filled in later
          maxPrice: 859, // To be filled in later
          variants: {} // Will be populated from data
        },
        product8: {
          id: null, // Will be set from data attribute
          minPrice: 860, // To be filled in later
          maxPrice: 948, // To be filled in later
          variants: {} // Will be populated from data
        },
        product9: {
          id: null, // Will be set from data attribute
          minPrice: 949, // To be filled in later
          maxPrice: 1048, // To be filled in later
          variants: {} // Will be populated from data
        },
        product10: {
          id: null, // Will be set from data attribute
          minPrice: 1049, // To be filled in later
          maxPrice: 1148, // To be filled in later
          variants: {} // Will be populated from data
        },
        product11: {
          id: null, // Will be set from data attribute
          minPrice: 1149, // To be filled in later
          maxPrice: 1268, // To be filled in later
          variants: {} // Will be populated from data
        },
        product12: {
          id: null, // Will be set from data attribute
          minPrice: 1269, // To be filled in later
          maxPrice: 1318, // To be filled in later
          variants: {} // Will be populated from data
        }
      };
      
      // Get product data from page
      const productData = document.querySelector('[data-product-variants]');
      
      if (productData) {
        const variantData = JSON.parse(productData.dataset.productVariants);
        
        this.products.product1.id = variantData.product1Id;
        this.products.product1.variants = variantData.product1Variants || {};
        
        this.products.product2.id = variantData.product2Id;
        this.products.product2.variants = variantData.product2Variants || {};
        
        this.products.product3.id = variantData.product3Id;
        this.products.product3.variants = variantData.product3Variants || {};
        
        this.products.product4.id = variantData.product4Id;
        this.products.product4.variants = variantData.product4Variants || {};
        
        this.products.product5.id = variantData.product5Id;
        this.products.product5.variants = variantData.product5Variants || {};
        
        this.products.product6.id = variantData.product6Id;
        this.products.product6.variants = variantData.product6Variants || {};
        
        this.products.product7.id = variantData.product7Id;
        this.products.product7.variants = variantData.product7Variants || {};
        
        this.products.product8.id = variantData.product8Id;
        this.products.product8.variants = variantData.product8Variants || {};
        
        this.products.product9.id = variantData.product9Id;
        this.products.product9.variants = variantData.product9Variants || {};
        
        this.products.product10.id = variantData.product10Id;
        this.products.product10.variants = variantData.product10Variants || {};
        
        this.products.product11.id = variantData.product11Id;
        this.products.product11.variants = variantData.product11Variants || {};
        
        this.products.product12.id = variantData.product12Id;
        this.products.product12.variants = variantData.product12Variants || {};
      } else {
        console.error('DEBUG: No product data element found!');
      }
      if (productData) {
        try {
          const parsed = JSON.parse(productData.dataset.productVariants);
        } catch (e) {
          console.error('Failed to parse variant data:', e);
        }
      }
      
      // Set base price from data attribute or use default
      const variantInput = document.getElementById('main-variant-id');
      this.basePrice = variantInput && variantInput.dataset.basePrice
        ? parseFloat(variantInput.dataset.basePrice)
        : 0;
      
      this.selectedOptions = {
        length: '31',
        wood: 'oak',
        finish: 'tung-oil',
        horn: 'inside-cut',
        crystal: null,
        grip: [],
        sharks: [],
        rumble: null,
        strikingEdges: [],
        mobilityCard: 'none',
        rubberTip: 'standard',
        addons: [],
        customEngraving: '',
        initialEngraving: ''
      };
      
      this.prices = {
        wood: {
          'oak': 60,
          'hickory': 60,
          'hickory-with-heartwood': 115,
          'pure-hickory': 185
        },
        finish: {
          'gunstock-brown': 55,
          'medium-brown': 55,
          'dark-brown': 55,
          'crimson': 65,
          'black-dye': 65,
          'tung-oil': 45
        },
        horn: {
          'inside-cut': 25,
          'round-horn': 30,
          'gentlemans': 30,
          'birds-head': 30,
          'tactical': 30,
          'elite': 30
        },
        crystal: {
          'green-round': 40,
          'green-lifelike': 40,
          'orange-lifelike': 40,
          'pink-lifelike': 40,
          'red-crystal': 40,
          'red-lifelike': 40,
          'white-crystal': 40,
          'yellow-crystal': 40,
          'yellow-lifelike': 40
        },
        grip: {
          'top-grips': 35,
          'middle-grips': 35,
          'bottom-grips': 35,
          'crook-grips': 35,
          'top-extended': 45,
          'full-length': 120,
          'full-lateral': 60
        },
        sharks: {
          '12-inch': 40,
          'full-length': 65,
          '12-angled': 65,
          '6-inside': 35
        },
        rumble: {
          '12-inch': 40,
          'double-12': 60,
          '24-inch': 45,
          'double-24': 65,
          'full-length': 60
        },
        strikingEdges: {
          'on-shaft': 40,
          'inside-bottom': 30
        },
        mobilityCard: {
          'none': 0,
          '1-card': 15,
          '2-pack': 25
        },
        rubberTip: {
          'none': 0,
          'standard': 0,
          'additional-rubber-tip': 4
        },
        addons: {
          'copper-tip': 45,
          'palm-rest': 99,
          'paracord-wrap': 45
        },
        engraving: {
          'custom': 50,
          'initial': 25
        }
      };
      
      this.init();
      
      // Load dynamic product data
      if (this.productLoader) {
        this.loadDynamicProductData();
      }
    }
    
    init() {
      this.bindEvents();
      this.initializeNoneSelections();
      this.updatePrice();
      this.updateFormProperties();
    }
    
    initializeNoneSelections() {
      // Ensure none checkboxes are checked and others are unchecked for optional selectors
      const optionalSelectors = ['crystal', 'grip', 'sharks', 'rumble', 'strikingEdges'];
      
      optionalSelectors.forEach(selector => {
        // Handle special case for strikingEdges which uses lowercase data attribute
        const dataAttr = selector === 'strikingEdges' ? 'strikingedges' : selector;
        
        // Uncheck all non-none checkboxes
        document.querySelectorAll(`.${selector}-checkbox:not([data-${dataAttr}="none"])`).forEach(cb => {
          cb.checked = false;
        });
        
        // Check the none checkbox
        const noneCheckbox = document.querySelector(`.${selector}-checkbox[data-${dataAttr}="none"]`);
        if (noneCheckbox) {
          noneCheckbox.checked = true;
        }
        
        // Update display to show "None selected"
        this.updateSelectedDisplay(selector, 'None selected');
        
        // Initialize arrays for grip, sharks, and strikingEdges
        if (selector === 'grip' || selector === 'sharks' || selector === 'strikingEdges') {
          this.selectedOptions[selector] = [];
        }
      });
    }
    
    bindEvents() {
      // Length selector
      const lengthSelect = document.getElementById('cane-length');
      if (lengthSelect) {
        lengthSelect.addEventListener('change', (e) => {
          this.selectedOptions.length = e.target.value;
          this.updateSelectedDisplay('length', `${e.target.value}"`);
          this.updatePrice();
          this.updateFormProperties();
        });
      }
      
      // Wood options
      document.querySelectorAll('.wood-option').forEach(option => {
        option.addEventListener('click', () => {
          this.selectOption('wood', option);
        });
      });
      
      // Finish options
      document.querySelectorAll('.finish-option').forEach(option => {
        option.addEventListener('click', () => {
          this.selectOption('finish', option);
        });
      });
      
      // Horn options
      document.querySelectorAll('.horn-option').forEach(option => {
        option.addEventListener('click', () => {
          this.selectOption('horn', option);
        });
      });
      
      // Crystal checkbox options with single selection
      document.querySelectorAll('.crystal-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            // Uncheck all other crystal checkboxes
            document.querySelectorAll('.crystal-checkbox').forEach(cb => {
              if (cb !== e.target) cb.checked = false;
            });
            
            // Handle none selection
            if (e.target.dataset.crystal === 'none') {
              this.selectedOptions.crystal = null;
              this.updateSelectedDisplay('crystal', 'None selected');
              this.updatePrice();
              this.updateFormProperties();
            } else {
              this.selectCheckboxOption('crystal', e.target);
            }
          } else {
            // If unchecking a non-none option, check the none option
            if (e.target.dataset.crystal !== 'none') {
              const noneCheckbox = document.querySelector('.crystal-checkbox[data-crystal="none"]');
              if (noneCheckbox) noneCheckbox.checked = true;
            }
            // Handle deselection
            this.selectedOptions.crystal = null;
            this.updateSelectedDisplay('crystal', 'None selected');
            this.updatePrice();
            this.updateFormProperties();
          }
        });
      });
      
      // Grip checkbox options with multiple selection
      document.querySelectorAll('.grip-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          const gripValue = e.target.dataset.grip;
          
          if (e.target.checked) {
            if (gripValue === 'none') {
              // If "None" is selected, clear all selections
              this.selectedOptions.grip = [];
              // Uncheck all other grip checkboxes
              document.querySelectorAll('.grip-checkbox:not([data-grip="none"])').forEach(cb => {
                cb.checked = false;
              });
              this.updateSelectedDisplay('grip', 'None selected');
            } else {
              // Uncheck "None" if any other option is selected
              const noneCheckbox = document.querySelector('.grip-checkbox[data-grip="none"]');
              if (noneCheckbox) noneCheckbox.checked = false;
              
              // Add to selected grips
              if (!this.selectedOptions.grip.includes(gripValue)) {
                this.selectedOptions.grip.push(gripValue);
              }
              this.updateMultipleSelectedDisplay('grip', this.selectedOptions.grip);
            }
          } else {
            // Remove from selected grips
            if (gripValue !== 'none') {
              this.selectedOptions.grip = this.selectedOptions.grip.filter(g => g !== gripValue);
              
              // If no grips are selected, check the "None" option
              if (this.selectedOptions.grip.length === 0) {
                const noneCheckbox = document.querySelector('.grip-checkbox[data-grip="none"]');
                if (noneCheckbox) noneCheckbox.checked = true;
                this.updateSelectedDisplay('grip', 'None selected');
              } else {
                this.updateMultipleSelectedDisplay('grip', this.selectedOptions.grip);
              }
            }
          }
          
          this.updatePrice();
          this.updateFormProperties();
        });
      });
      
      // Sharks teeth checkbox options with multiple selection
      document.querySelectorAll('.sharks-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          const sharksValue = e.target.dataset.sharks;
          
          if (e.target.checked) {
            if (sharksValue === 'none') {
              // If "None" is selected, clear all selections
              this.selectedOptions.sharks = [];
              // Uncheck all other sharks checkboxes
              document.querySelectorAll('.sharks-checkbox:not([data-sharks="none"])').forEach(cb => {
                cb.checked = false;
              });
              this.updateSelectedDisplay('sharks', 'None selected');
            } else {
              // Uncheck "None" if any other option is selected
              const noneCheckbox = document.querySelector('.sharks-checkbox[data-sharks="none"]');
              if (noneCheckbox) noneCheckbox.checked = false;
              
              // Add to selected sharks
              if (!this.selectedOptions.sharks.includes(sharksValue)) {
                this.selectedOptions.sharks.push(sharksValue);
              }
              this.updateMultipleSelectedDisplay('sharks', this.selectedOptions.sharks);
            }
          } else {
            // Remove from selected sharks
            if (sharksValue !== 'none') {
              this.selectedOptions.sharks = this.selectedOptions.sharks.filter(s => s !== sharksValue);
              
              // If no sharks are selected, check the "None" option
              if (this.selectedOptions.sharks.length === 0) {
                const noneCheckbox = document.querySelector('.sharks-checkbox[data-sharks="none"]');
                if (noneCheckbox) noneCheckbox.checked = true;
                this.updateSelectedDisplay('sharks', 'None selected');
              } else {
                this.updateMultipleSelectedDisplay('sharks', this.selectedOptions.sharks);
              }
            }
          }
          
          this.updatePrice();
          this.updateFormProperties();
        });
      });
      
      // Rumble strip checkbox options with single selection
      document.querySelectorAll('.rumble-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            // Uncheck all other rumble checkboxes
            document.querySelectorAll('.rumble-checkbox').forEach(cb => {
              if (cb !== e.target) cb.checked = false;
            });
            
            // Handle none selection
            if (e.target.dataset.rumble === 'none') {
              this.selectedOptions.rumble = null;
              this.updateSelectedDisplay('rumble', 'None selected');
              this.updatePrice();
              this.updateFormProperties();
            } else {
              this.selectCheckboxOption('rumble', e.target);
            }
          } else {
            // If unchecking a non-none option, check the none option
            if (e.target.dataset.rumble !== 'none') {
              const noneCheckbox = document.querySelector('.rumble-checkbox[data-rumble="none"]');
              if (noneCheckbox) noneCheckbox.checked = true;
            }
            // Handle deselection
            this.selectedOptions.rumble = null;
            this.updateSelectedDisplay('rumble', 'None selected');
            this.updatePrice();
            this.updateFormProperties();
          }
        });
      });
      
      // Striking Edges checkbox options with multiple selection
      document.querySelectorAll('.strikingEdges-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          const strikingEdgesValue = e.target.dataset.strikingedges;
          
          if (e.target.checked) {
            if (strikingEdgesValue === 'none') {
              // If "None" is selected, clear all selections
              this.selectedOptions.strikingEdges = [];
              // Uncheck all other strikingEdges checkboxes
              document.querySelectorAll('.strikingEdges-checkbox:not([data-strikingedges="none"])').forEach(cb => {
                cb.checked = false;
              });
              this.updateSelectedDisplay('strikingEdges', 'None selected');
            } else {
              // Uncheck "None" if any other option is selected
              const noneCheckbox = document.querySelector('.strikingEdges-checkbox[data-strikingedges="none"]');
              if (noneCheckbox) noneCheckbox.checked = false;
              
              // Add to selected strikingEdges
              if (!this.selectedOptions.strikingEdges.includes(strikingEdgesValue)) {
                this.selectedOptions.strikingEdges.push(strikingEdgesValue);
              }
              this.updateMultipleSelectedDisplay('strikingEdges', this.selectedOptions.strikingEdges);
            }
          } else {
            // Remove from selected strikingEdges
            if (strikingEdgesValue !== 'none') {
              this.selectedOptions.strikingEdges = this.selectedOptions.strikingEdges.filter(s => s !== strikingEdgesValue);
              
              // If no strikingEdges are selected, check the "None" option
              if (this.selectedOptions.strikingEdges.length === 0) {
                const noneCheckbox = document.querySelector('.strikingEdges-checkbox[data-strikingedges="none"]');
                if (noneCheckbox) noneCheckbox.checked = true;
                this.updateSelectedDisplay('strikingEdges', 'None selected');
              } else {
                this.updateMultipleSelectedDisplay('strikingEdges', this.selectedOptions.strikingEdges);
              }
            }
          }
          
          this.updatePrice();
          this.updateFormProperties();
        });
      });
      
      // Mobility card selector
      const mobilitySelect = document.getElementById('mobility-card');
      if (mobilitySelect) {
        mobilitySelect.addEventListener('change', (e) => {
          this.selectedOptions.mobilityCard = e.target.value;
          const option = e.target.selectedOptions[0];
          const price = this.prices.mobilityCard[e.target.value] || 0;
          if (price > 0) {
            this.updateSelectedDisplay('card', `${option.text} (+$${price})`);
          } else {
            this.updateSelectedDisplay('card', option.text);
          }
          this.updatePrice();
          this.updateFormProperties();
        });
      }
      
      // Rubber tip selector
      const rubberTipSelect = document.getElementById('rubber-tips');
      if (rubberTipSelect) {
        rubberTipSelect.addEventListener('change', (e) => {
          this.selectedOptions.rubberTip = e.target.value;
          const option = e.target.selectedOptions[0];
          const price = this.prices.rubberTip[e.target.value] || 0;
          if (price > 0) {
            this.updateSelectedDisplay('rubber-tips', `${option.text} (+$${price})`);
          } else {
            this.updateSelectedDisplay('rubber-tips', option.text);
          }
          this.updatePrice();
          this.updateFormProperties();
        });
      }
      
      // Add-on checkboxes
      document.querySelectorAll('.addon-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          this.handleAddonChange(checkbox);
        });
      });
      
      // Engraving inputs
      const customEngraving = document.getElementById('custom-engraving');
      if (customEngraving) {
        customEngraving.addEventListener('input', (e) => {
          this.selectedOptions.customEngraving = e.target.value;
          this.updatePrice();
          this.updateFormProperties();
        });
      }
      
      const initialEngraving = document.getElementById('initial-engraving');
      if (initialEngraving) {
        initialEngraving.addEventListener('input', (e) => {
          this.selectedOptions.initialEngraving = e.target.value;
          this.updatePrice();
          this.updateFormProperties();
        });
      }
    }
    
    selectOption(category, element) {
      // Remove active class from siblings
      element.parentElement.querySelectorAll(`.${category}-option`).forEach(opt => {
        opt.classList.remove('active');
      });
      
      // Add active class to selected
      element.classList.add('active');
      
      // Update selected value
      const value = element.dataset[category];
      this.selectedOptions[category] = value;
      
      // Update display
      const name = element.querySelector(`.${category}-name`).textContent;
      const price = this.prices[category][value] || 0;
      const displayText = price > 0 ? `${name} (+$${price})` : name;
      this.updateSelectedDisplay(category, displayText);
      
      // Update price
      this.updatePrice();
      this.updateFormProperties();
    }
    
    selectCheckboxOption(category, checkbox) {
      // Get the associated option div which has the data attributes
      const optionDiv = checkbox.parentElement.querySelector(`.${category}-option`);
      
      // Update selected value from the div's data attribute
      const value = optionDiv.dataset[category];
      this.selectedOptions[category] = value;
      
      // Get the name from the option div
      const name = optionDiv.querySelector(`.${category}-name`).textContent;
      const price = parseFloat(checkbox.dataset.price) || this.prices[category][value] || 0;
      const displayText = price > 0 ? `${name} (+$${price})` : name;
      this.updateSelectedDisplay(category, displayText);
      
      // Update price
      this.updatePrice();
      this.updateFormProperties();
    }
    
    handleAddonChange(checkbox) {
      const addon = checkbox.dataset.addon;
      
      if (checkbox.checked) {
        // Add addon if not already present
        if (!this.selectedOptions.addons.includes(addon)) {
          this.selectedOptions.addons.push(addon);
        }
      } else {
        // Remove addon
        this.selectedOptions.addons = this.selectedOptions.addons.filter(a => a !== addon);
      }
      
      this.updateAddonDisplay();
      this.updatePrice();
      this.updateFormProperties();
    }
    
    updateAddonDisplay() {
      const selectedAddons = this.selectedOptions.addons;
      const displayElement = document.getElementById('selected-addons');
      
      // if (displayElement) {
      //   if (selectedAddons.length === 0) {
      //     displayElement.textContent = 'None selected';
      //   } else {
      //     const addonNames = {
      //       'copper-tip': 'Copper Tip',
      //       'palm-rest': 'Palm Rest',
      //       'paracord-wrap': 'Paracord Wrap'
      //     };
      //     const names = selectedAddons.map(a => addonNames[a] || a);
      //     displayElement.textContent = names.join(', ');
      //   }
      // }
    }
    
    resetAllCustomizations() {
      // Reset optional selectors to "none"
      const optionalSelectors = ['crystal', 'grip', 'sharks', 'rumble', 'strikingEdges'];
      
      optionalSelectors.forEach(selector => {
        // Set option to null or empty array
        if (selector === 'grip' || selector === 'sharks' || selector === 'strikingEdges') {
          this.selectedOptions[selector] = [];
        } else {
          this.selectedOptions[selector] = null;
        }
        
        // Handle special case for strikingEdges which uses lowercase data attribute
        const dataAttr = selector === 'strikingEdges' ? 'strikingedges' : selector;
        
        // Uncheck all non-none checkboxes
        document.querySelectorAll(`.${selector}-checkbox:not([data-${dataAttr}="none"])`).forEach(cb => {
          cb.checked = false;
        });
        
        // Check the none checkbox
        const noneCheckbox = document.querySelector(`.${selector}-checkbox[data-${dataAttr}="none"]`);
        if (noneCheckbox) {
          noneCheckbox.checked = true;
        }
        
        // Update display to show "None selected"
        this.updateSelectedDisplay(selector, 'None selected');
      });
      
      // Clear the addons array
      this.selectedOptions.addons = [];
      
      // Uncheck all addon checkboxes
      document.querySelectorAll('.addon-checkbox').forEach(checkbox => {
        checkbox.checked = false;
      });
      
      // Clear engraving text
      this.selectedOptions.customEngraving = '';
      this.selectedOptions.initialEngraving = '';
      
      // Clear text inputs
      const customEngravingInput = document.getElementById('custom-engraving');
      if (customEngravingInput) {
        customEngravingInput.value = '';
      }
      
      const initialEngravingInput = document.getElementById('initial-engraving');
      if (initialEngravingInput) {
        initialEngravingInput.value = '';
      }
      
      // Update the display
      this.updateAddonDisplay();
      
      // Update price
      this.updatePrice();
      
      // Update form properties
      this.updateFormProperties();
    }
    
    updateSelectedDisplay(category, text) {
      const displayElement = document.getElementById(`selected-${category}`);
      if (displayElement) {
        displayElement.textContent = text;
      }
    }
    
    updateMultipleSelectedDisplay(category, selectedValues) {
      const displayElement = document.getElementById(`selected-${category}`);
      if (displayElement) {
        if (selectedValues.length === 0) {
          displayElement.textContent = 'None selected';
        } else {
          // Get the names and prices for selected options
          const names = [];
          let totalPrice = 0;
          
          selectedValues.forEach(value => {
            const name = category === 'grip' ? this.getGripName(value) : 
                        category === 'sharks' ? this.getSharksName(value) :
                        this.getStrikingEdgesName(value);
            const price = this.prices[category === 'grip' ? 'grip' : 
                                      category === 'sharks' ? 'sharks' : 
                                      'strikingEdges'][value] || 0;
            names.push(name);
            totalPrice += price;
          });
          
          const displayText = totalPrice > 0 
            ? `${names.join(', ')} (+$${totalPrice})` 
            : names.join(', ');
          displayElement.textContent = displayText;
        }
      }
    }
    
    updatePrice() {
      const total = this.calculateTotalPrice();
      
      // Update price display
      const priceElements = document.querySelectorAll('#total-price');
      priceElements.forEach(priceElement => {
        priceElement.textContent = `$${total}`;
      });
      
    }
    
    calculateTotalPrice() {
      let total = this.basePrice;
      
      // Add option prices
      Object.keys(this.prices).forEach(category => {
        if (category === 'addons' || category === 'engraving') return;
        
        const selectedValue = this.selectedOptions[category];
        
        // Handle arrays for grip, sharks, and strikingEdges
        if (category === 'grip' || category === 'sharks' || category === 'strikingEdges') {
          if (Array.isArray(selectedValue)) {
            selectedValue.forEach(value => {
              if (this.prices[category][value]) {
                total += this.prices[category][value];
              }
            });
          }
        } else {
          // Handle single values for other categories
          if (selectedValue && selectedValue !== null && this.prices[category][selectedValue]) {
            total += this.prices[category][selectedValue];
          }
        }
      });
      
      // Add addon prices
      this.selectedOptions.addons.forEach(addon => {
        if (this.prices.addons[addon]) {
          total += this.prices.addons[addon];
        }
      });
      
      // Add engraving prices
      if (this.selectedOptions.customEngraving && this.selectedOptions.customEngraving.trim() !== '') {
        total += this.prices.engraving['custom'];
      }
      
      if (this.selectedOptions.initialEngraving && this.selectedOptions.initialEngraving.trim() !== '') {
        total += this.prices.engraving['initial'];
      }
      
      return total;
    }
    
    getProductAndVariant() {
      const totalPrice = this.calculateTotalPrice();
      
      // Determine which product to use based on price thresholds
      let productType = 'product1';
      let productId = this.products.product1.id;
      let variants = this.products.product1.variants;
      
      // Check each product tier from highest to lowest
      for (let i = 12; i >= 1; i--) {
        const product = this.products[`product${i}`];
        console.log(`DEBUG: Checking product${i} - minPrice: ${product.minPrice}, maxPrice: ${product.maxPrice}`);
        if (product.minPrice && totalPrice >= product.minPrice) {
          productType = `product${i}`;
          productId = product.id;
          variants = product.variants;
          break;
        }
      }
      
      // Find the variant with matching price
      const variantId = variants[totalPrice.toString()];
      
      if (!variantId) {
        console.error(`No variant found for price $${totalPrice}`);
        return null;
      }
      
      return {
        productId: productId,
        variantId: variantId,
        productType: productType,
        price: totalPrice
      };
    }
    
    updateFormProperties() {
      // Update hidden form inputs
      const updates = {
        'length-property': this.selectedOptions.length + '"',
        'wood-property': this.getWoodName(this.selectedOptions.wood),
        'finish-property': this.getFinishName(this.selectedOptions.finish),
        'horn-property': this.getHornName(this.selectedOptions.horn),
        'crystal-property': this.selectedOptions.crystal ? this.getCrystalName(this.selectedOptions.crystal) : '',
        'grip-property': this.selectedOptions.grip.length > 0 ? this.selectedOptions.grip.map(g => this.getGripName(g)).join(', ') : '',
        'sharks-property': this.selectedOptions.sharks.length > 0 ? this.selectedOptions.sharks.map(s => this.getSharksName(s)).join(', ') : '',
        'rumble-property': this.selectedOptions.rumble ? this.getRumbleName(this.selectedOptions.rumble) : '',
        'strikingEdges-property': this.selectedOptions.strikingEdges.length > 0 ? this.selectedOptions.strikingEdges.map(se => this.getStrikingEdgesName(se)).join(', ') : '',
        'custom-engraving-property': this.selectedOptions.customEngraving || '',
        'initial-engraving-property': this.selectedOptions.initialEngraving || ''
      };
      
      Object.keys(updates).forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          element.value = updates[id];
        }
      });
    }
    
    // Helper methods to get readable names
    getWoodName(value) {
      const names = {
        'oak': 'Oak',
        'hickory': 'Hickory',
        'hickory-with-heartwood': 'Hickory with Heartwood',
        'pure-hickory': 'Pure Hickory'
      };
      return names[value] || value;
    }
    
    getFinishName(value) {
      const names = {
        'gunstock-brown': 'Gunstock Brown',
        'medium-brown': 'Medium Brown',
        'dark-brown': 'Dark Brown',
        'crimson': 'Crimson',
        'black-dye': 'Black Dye',
        'tung-oil': 'Tung Oil'
      };
      return names[value] || value;
    }
    
    getHornName(value) {
      const names = {
        'inside-cut': 'Inside Cut',
        'round-horn': 'Round Horn',
        'gentlemans': 'Gentlemans',
        'birds-head': 'Birds Head',
        'tactical': 'Tactical',
        'elite': 'Elite'
      };
      return names[value] || value;
    }
    
    getCrystalName(value) {
      if (!value) return '';
      const names = {
        'green-round': 'Green Round',
        'green-lifelike': 'Green Lifelike',
        'orange-lifelike': 'Orange Lifelike',
        'pink-lifelike': 'Pink Lifelike',
        'red-crystal': 'Red Crystal',
        'red-lifelike': 'Red Lifelike',
        'white-crystal': 'White Crystal',
        'yellow-crystal': 'Yellow Crystal',
        'yellow-lifelike': 'Yellow Lifelike'
      };
      return names[value] || value;
    }
    
    getGripName(value) {
      if (!value) return '';
      const names = {
        'top-grips': 'Top Grips',
        'middle-grips': 'Middle Grips',
        'bottom-grips': 'Bottom Grips',
        'crook-grips': 'On the Crook',
        'top-extended': 'Top Grips (Extended)',
        'full-length': 'Full Length Grips',
        'full-lateral': 'Full Length Grips (Lateral)'
      };
      return names[value] || value;
    }
    
    getSharksName(value) {
      if (!value) return '';
      const names = {
        '12-inch': '12"',
        'full-length': 'Full Length',
        '12-angled': '12" Angled',
        '6-inside': '6" Inside Bottom'
      };
      return names[value] || value;
    }
    
    getRumbleName(value) {
      if (!value) return '';
      const names = {
        '12-inch': '12"',
        'double-12': 'Double 12"',
        '24-inch': '24"',
        'double-24': 'Double 24"',
        'full-length': 'Full Length'
      };
      return names[value] || value;
    }
    
    getStrikingEdgesName(value) {
      if (!value) return '';
      const names = {
        'on-shaft': 'On Shaft',
        'inside-bottom': 'Inside Bottom of Shaft'
      };
      return names[value] || value;
    }
    
    // Load dynamic product data from Shopify
    async loadDynamicProductData() {
      try {
        // Load all product data
        await this.productLoader.initializeAllOptions();
        
        // Update prices object with fetched data
        await this.updatePricesFromProducts();
        
        // Recalculate price with new data
        this.updatePrice();
      } catch (error) {
        console.error('Error loading dynamic product data:', error);
      }
    }
    
    // Update internal prices from fetched products
    async updatePricesFromProducts() {
      const types = ['horn-style', 'eyes', 'grips', 'sharks', 'rumble'];
      
      for (const type of types) {
        const products = await this.productLoader.fetchProductsByType(type);
        
        // Map type to price category
        let priceCategory;
        switch(type) {
          case 'horn-style': priceCategory = 'horn'; break;
          case 'eyes': priceCategory = 'crystal'; break;
          case 'sharks': priceCategory = 'sharks'; break;
          case 'rumble': priceCategory = 'rumble'; break;
          default: priceCategory = type;
        }
        
        // Update prices for each product
        products.forEach((productData, index) => {
          const slugs = this.getSlugsByTypeAndIndex(type, index);
          if (slugs && this.prices[priceCategory]) {
            this.prices[priceCategory][slugs] = productData.price;
          }
        });
      }
    }
    
    // Helper to map type and index to slug
    getSlugsByTypeAndIndex(type, index) {
      const slugMappings = {
        'horn-style': ['inside-cut', 'round-horn', 'gentlemans', 'birds-head', 'tactical', 'elite'],
        'eyes': ['green-round', 'green-lifelike', 'orange-lifelike', 'pink-lifelike', 'red-crystal', 'red-lifelike', 'white-crystal', 'yellow-crystal', 'yellow-lifelike'],
        'grips': ['top-grips', 'middle-grips', 'bottom-grips', 'crook-grips', 'top-extended', 'full-length', 'full-lateral'],
        'sharks': ['12-inch', 'full-length', '12-angled', '6-inside'],
        'rumble': ['12-inch', 'double-12', '24-inch', 'double-24', 'full-length']
      };
      
      return slugMappings[type]?.[index];
    }
    
    // Multi-product form submission with specific variant selection
    async handleFormSubmission() {
      // Prevent multiple submissions
      const submitButton = document.querySelector('.ProductForm__AddToCart');
      if (submitButton && submitButton.disabled) {
        return; // Already submitting
      }
      
      try {
        // Disable submit button and show loading state
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.innerHTML = '<span class="loading">Adding to cart...</span>';
        }
        
        // Get the correct product and variant
        const productInfo = this.getProductAndVariant();
        
        if (!productInfo) {
          throw new Error('Please contact support at 561-556-7314');
        }
        
        const quantity = parseInt(document.querySelector('.QuantitySelector__CurrentQuantity')?.value) || 1;
        
        // Create product data with the specific variant ID
        const productData = {
          id: productInfo.variantId,
          quantity: quantity,
          properties: {
            '_product_title': 'Design Your Own Cane',  // Hidden property for cart display
            'Cane Length': this.selectedOptions.length + '"',
            'Wood Type': this.getWoodName(this.selectedOptions.wood),
            'Finish': this.getFinishName(this.selectedOptions.finish),
            'Horn Style': this.getHornName(this.selectedOptions.horn)
          }
        };
        
        // Only add optional properties if they are selected
        if (this.selectedOptions.crystal) {
          productData.properties['Eyes/Crystal'] = this.getCrystalName(this.selectedOptions.crystal);
        }
        if (this.selectedOptions.grip && this.selectedOptions.grip.length > 0) {
          const gripNames = this.selectedOptions.grip.map(g => this.getGripName(g));
          productData.properties['Grip Style'] = gripNames.join(', ');
        }
        if (this.selectedOptions.sharks && this.selectedOptions.sharks.length > 0) {
          const sharksNames = this.selectedOptions.sharks.map(s => this.getSharksName(s));
          productData.properties['Sharks Teeth'] = sharksNames.join(', ');
        }
        if (this.selectedOptions.rumble) {
          productData.properties['Rumble Strips'] = this.getRumbleName(this.selectedOptions.rumble);
        }
        if (this.selectedOptions.strikingEdges && this.selectedOptions.strikingEdges.length > 0) {
          const strikingEdgesNames = this.selectedOptions.strikingEdges.map(se => this.getStrikingEdgesName(se));
          productData.properties['Striking Edges'] = strikingEdgesNames.join(', ');
        }
        
        // Add optional items if selected
        if (this.selectedOptions.mobilityCard !== 'none') {
          productData.properties['Mobility Card'] = this.selectedOptions.mobilityCard === '1-card' 
            ? '1 Card' 
            : '2 Pack';
        }
        
        if (this.selectedOptions.rubberTip !== 'none' && this.selectedOptions.rubberTip !== 'standard') {
          const tipNames = {
            'standard': 'Standard',
            'additional-rubber-tip': 'Additional Rubber Tip'
          };
          productData.properties['Rubber Tip'] = tipNames[this.selectedOptions.rubberTip] || this.selectedOptions.rubberTip;
        }
        
        // Add selected addons
        if (this.selectedOptions.addons.length > 0) {
          const addonNames = {
            'copper-tip': 'Copper Tip',
            'palm-rest': 'Palm Rest',
            'paracord-wrap': 'Paracord Wrap'
          };
          const addonList = this.selectedOptions.addons.map(a => addonNames[a] || a);
          productData.properties['Add-ons'] = addonList.join(', ');
        }
        
        // Add engraving if provided
        const customEngraving = document.getElementById('custom-engraving')?.value;
        const initialEngraving = document.getElementById('initial-engraving')?.value;
        
        if (customEngraving && customEngraving.trim() !== '') {
          productData.properties['Custom Engraving'] = `${customEngraving} (+$${this.prices.engraving['custom']})`;
        }
        
        if (initialEngraving && initialEngraving.trim() !== '') {
          productData.properties['Initial Engraving'] = `${initialEngraving} (+$${this.prices.engraving['initial']})`;
        }
        
        console.log('Adding to cart:', productData);
        
        // Add to cart with retry logic for rate limiting
        let attempts = 0;
        let response;
        
        while (attempts < 3) {
          try {
            response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(productData)
            });
            
            if (response.ok) {
              break; // Success, exit the loop
            }
            
            const errorText = await response.text();
            let errorData;
            try {
              errorData = JSON.parse(errorText);
            } catch {
              errorData = { message: errorText };
            }
            
            // Check if it's a rate limit error
            if (response.status === 429 || errorData.status === 'too_many_requests') {
              attempts++;
              if (attempts < 3) {
                console.log(`Rate limited. Waiting ${attempts * 2} seconds before retry...`);
                await new Promise(resolve => setTimeout(resolve, attempts * 2000));
                continue;
              }
            }
            
            // Not a rate limit error, throw immediately
            console.error('Failed to add to cart:', errorText);
            throw new Error(`Failed to add to cart: ${errorText}`);
            
          } catch (error) {
            if (attempts >= 2) {
              throw error;
            }
            attempts++;
            console.log(`Network error. Waiting ${attempts * 2} seconds before retry...`);
            await new Promise(resolve => setTimeout(resolve, attempts * 2000));
          }
        }
        
        if (!response || !response.ok) {
          throw new Error('Failed to add to cart after multiple attempts');
        }
        
        
        setTimeout(() => {
          if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
            window.CartDrawer.open();
          } else if (window.theme && window.theme.cartDrawer) {
            window.theme.cartDrawer.open();
          } else {
            window.location.href = '/cart';
          }
        }, 500);
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showErrorMessage(error.message);
      } finally {
        // Re-enable submit button
        const submitButton = document.querySelector('.ProductForm__AddToCart');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerHTML = '<span>Add to cart</span>';
        }
      }
    }
    
    
    showErrorMessage(message) {
      const errorElement = document.querySelector('.product_form_error');
      if (errorElement) {
        errorElement.textContent = `Error: ${message}, or refresh the page and try again.`;
        errorElement.style.color = 'red';
        errorElement.classList.remove('hide');
      }
    }
  }
  
  // Initialize customizer
  const customizer = new CaneCustomizer();
  
  // Make customizer globally available for dynamic price updates
  window.caneCustomizer = customizer;
  
  // Reset checkboxes and text inputs on initial load
  document.querySelectorAll('.addon-checkbox').forEach(checkbox => {
    checkbox.checked = false;
  });
  
  // Reset text inputs
  const customEngravingInput = document.getElementById('custom-engraving');
  if (customEngravingInput) {
    customEngravingInput.value = '';
  }
  
  const initialEngravingInput = document.getElementById('initial-engraving');
  if (initialEngravingInput) {
    initialEngravingInput.value = '';
  }
  
  customizer.resetAllCustomizations();
  
  // Handle form submission
  const productForm = document.querySelector('.ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      await customizer.handleFormSubmission();
    });
  }
  
  // Handle quantity selector
  const quantityButtons = document.querySelectorAll('.QuantitySelector .QuantitySelector__Button');
  const quantityInput = document.querySelector('.ProductForm .ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity');
  
  if (quantityButtons.length > 0 && quantityInput) {
    quantityButtons.forEach(button => {
      button.addEventListener('click', function() {
        const currentVal = parseInt(quantityInput.value) || 1;
        
        if (button.dataset.action === 'increase-quantity') {
          quantityInput.value = currentVal + 1;
        } else if (button.dataset.action === 'decrease-quantity' && currentVal > 1) {
          quantityInput.value = currentVal - 1;
        }
      });
    });
  }
  
  // Handle length guide modal
  const lengthGuideBtn = document.querySelector('[data-action="open-length-guide"]');
  if (lengthGuideBtn) {
    lengthGuideBtn.addEventListener('click', function() {
      // Open the existing length guide modal
      const modal = document.querySelector('.hulk-modal');
      if (modal) {
        modal.style.display = 'block';
      }
    });
  }
  
  // Handle popup functionality
  const popupMain = document.querySelector('.popup_main');
  const popupOverlay = document.querySelector('.popup_overlay');
  const closeBtn = document.querySelector('.popup_main_title svg');
  
  if (popupMain && popupOverlay && closeBtn) {
    // Function to close popup
    function closePopup() {
      popupMain.style.display = 'none';
      document.body.style.overflow = '';
    }
    
    // Close on overlay click
    popupOverlay.addEventListener('click', closePopup);
    
    // Close on close button click
    closeBtn.addEventListener('click', closePopup);
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popupMain.style.display === 'block') {
        closePopup();
      }
    });
  }
});

// Handle page show event to reset checkboxes on back navigation
window.addEventListener('pageshow', function(event) {
  console.log('Pageshow event fired, persisted:', event.persisted);
  
  // Check if page is being loaded from cache (back/forward navigation)
  if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
    console.log('Page loaded from cache, resetting form fields...');
    
    // Reset all addon checkboxes
    const checkboxes = document.querySelectorAll('.addon-checkbox');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    
    // Reset text inputs - try multiple selectors
    const customEngravingInput = document.getElementById('custom-engraving') || document.querySelector('#custom-engraving') || document.querySelector('[name="custom_engraving"]');
    if (customEngravingInput) {
      console.log('Resetting custom engraving, current value:', customEngravingInput.value);
      customEngravingInput.value = '';
      // Force update
      customEngravingInput.setAttribute('value', '');
      // Trigger change event
      customEngravingInput.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      console.log('Custom engraving input not found');
    }
    
    const initialEngravingInput = document.getElementById('initial-engraving') || document.querySelector('#initial-engraving') || document.querySelector('[name="initial_engraving"]');
    if (initialEngravingInput) {
      console.log('Resetting initial engraving, current value:', initialEngravingInput.value);
      initialEngravingInput.value = '';
      // Force update
      initialEngravingInput.setAttribute('value', '');
      // Trigger change event
      initialEngravingInput.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      console.log('Initial engraving input not found');
    }
    
    // If CaneCustomizer instance exists, reset its state
    if (window.caneCustomizer) {
      window.caneCustomizer.resetAllCustomizations();
    }
  }
});

// Also reset on DOMContentLoaded for regular navigation
document.addEventListener('DOMContentLoaded', function() {
  // Function to reset inputs
  function resetEngravingInputs() {
    const customEngravingInput = document.getElementById('custom-engraving');
    const initialEngravingInput = document.getElementById('initial-engraving');
    
    if (customEngravingInput && customEngravingInput.value) {
      console.log('Clearing custom engraving on load');
      customEngravingInput.value = '';
      customEngravingInput.defaultValue = '';
    }
    
    if (initialEngravingInput && initialEngravingInput.value) {
      console.log('Clearing initial engraving on load');
      initialEngravingInput.value = '';
      initialEngravingInput.defaultValue = '';
    }
  }
  
  // Try immediately
  resetEngravingInputs();
  
  // Try with delay
  setTimeout(resetEngravingInputs, 100);
  setTimeout(resetEngravingInputs, 500);
});

// More aggressive approach for Safari/iOS
window.addEventListener('load', function() {
  // Force reset all text inputs and textareas in the customizer
  document.querySelectorAll('.customizer-input, .customizer-textarea, #custom-engraving, #initial-engraving').forEach(input => {
    if (input.tagName === 'INPUT' || input.tagName === 'TEXTAREA') {
      input.value = '';
      input.defaultValue = '';
      console.log('Force reset input:', input.id || input.name);
    }
  });
});